import Alpine from 'alpinejs';

export default function() {
  window.Alpine = Alpine;

  Alpine.store('backdrop', {
    show: false,
    zindex: '',
    showBackdrop() {
      this.show = true;
    },
    hideBackdrop() {
      this.show = false;
    },
    toggle() {
      this.show = !this.show;
    },
    setState(state) {
      if (state !== this.show) {
        this.show = state;
      }
    }
  });

  Alpine.store('mobileNav', {
    show: false,
    toggle() {
      this.show = !this.show;
    },
    hide() {
      this.show = false;
    }
  });

  Alpine.store('downloadModal', {
    show: false,
    downloadId: null,
    toggle(downloadId = null) {
      this.show = !this.show;
      this.downloadId = downloadId;
      if (this.show) {
        const downloadIdElId = '547c8e4b-aea8-4d23-c5ff-ca0e7898ba9d';
        const downloadIdEl = document.getElementById(downloadIdElId);
        if (downloadIdEl) downloadIdEl.value = downloadId;
      }
    },
    hide() {
      this.show = false;
      this.downloadId = null;
    }
  });

  Alpine.store('searchPanel', {
    show: false,
    toggle() {
      this.show = !this.show;
    },
    hide() {
      this.show = false;
    }
  });

  Alpine.store('headerNavBar', {
    hovered: false,
    toggle() {
      console.log(this.hovered);
    },
    setState(state) {
      if (state !== this.hovered) {
        this.hovered = state;
      }
    }
  });

  Alpine.start();
}
